import ApiService from "@/common/api.service";
import {
  SUBNOTE_CREATE,
  SUBNOTE_UPDATE,
  SUBNOTE_DELETE,
  FETCH_SUBNOTES,
  FETCH_NOTE_SUBNOTES
} from "./actions.type";
import {
  SET_SUBNOTES,
  DELETE_SUBNOTE,
  PURGE_SUBNOTES
} from "./mutations.type";

const state = {
  subnotes: []
};

const getters = {
  subnotes(state) {
    return state.subnotes;
  }
};

export const actions = {  
  [SUBNOTE_CREATE]({ commit }, params) {
    ApiService.setHeader();
    return ApiService.post("folders/" + params.folder_slug + "/notes/" + params.note_slug + "/subnotes/", params.subNoteData)
    .then(({ data }) => {
      console.log(data);
      console.log(commit);
    })
  },
  [SUBNOTE_UPDATE]({ commit }, params) {
    ApiService.setHeader();
    return ApiService.update("subnotes/" + params.subnote_id + "/", params.subNoteData)
    .then(({ data }) => {
      console.log(data);
      console.log(commit);
    })
  },  
  [FETCH_SUBNOTES]({ commit }, params) {
    commit(PURGE_SUBNOTES);
    ApiService.setHeader();
    return ApiService.get("searchclass/" + params.link_id + "/subnotes/")
    .then(({ data }) => {
      commit(SET_SUBNOTES, data);
    })
  },
  [FETCH_NOTE_SUBNOTES]({ commit }, params) {
    commit(PURGE_SUBNOTES);
    ApiService.setHeader();
    return ApiService.get("folders/" + params.folder_slug + "/notes/" + params.note_slug + "/subnotes/")
    .then(({ data }) => {
      commit(SET_SUBNOTES, data);
    })
  },
  [SUBNOTE_DELETE]({ commit }, subnote) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.delete("subnotes/" + subnote + "/")
        .then(({ data }) => {
          commit(DELETE_SUBNOTE, subnote);
          resolve(data);
        })
    });
  }
}

const mutations = {
  [PURGE_SUBNOTES](state) {
    state.subnotes = [];
  },
  [SET_SUBNOTES](state, serializer) {
    state.subnotes = serializer;
  },
  [DELETE_SUBNOTE](state, subnote) {
    let subnotes = state.subnotes
    let i = subnotes.length;
    while (i--) {
      if(subnote === subnotes[i].subnote_id) {
          subnotes.splice(i, 1);
      }
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
};